(function () {
  var predictiveSearchEl = document.querySelector('#menu-drawer predictive-search');
  var drawerEl = document.querySelector('#menu-drawer');
  if (!predictiveSearchEl || !drawerEl) return;

  var resultsEl = predictiveSearchEl.querySelector('[data-predictive-search]');
  if (!resultsEl) return;

  function correctMaxHeight() {
    if (!predictiveSearchEl.hasAttribute('open')) return;
    var drawerBottom = drawerEl.getBoundingClientRect().bottom;
    var resultsTop = resultsEl.getBoundingClientRect().top;
    var correctedMaxHeight = drawerBottom - resultsTop;
    if (correctedMaxHeight > 0) {
      resultsEl.style.maxHeight = correctedMaxHeight + 'px';
    }
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'open') {
        correctMaxHeight();
        return;
      }
    }
  }).observe(predictiveSearchEl, { attributes: true, attributeFilter: ['open'] });
})();
